import { Text } from 'ui';
import { useTranslation } from 'react-i18next';
import ExperienceDynamicCancelConditions from './ExperienceDynamicCancelConditions';
import { KoobCard, sanitizeRichText } from '@koob/ui';

const ExperienceCancelConditions = ({
  experience,
  currency,
  index,
  translationKey,
}) => {
  const { t } = useTranslation(translationKey);

  return (
    <KoobCard key={index}>
      <div className="font-medium text-gray-500 text-gray-800 mb-4">
        <Text color="textLight" fontWeight={700}>
          {t('booking:contractingConditions')}
        </Text>
      </div>
      <ExperienceDynamicCancelConditions
        currency={currency}
        translationKey={translationKey}
        cancelConditions={experience?.cancelConditions?.details}
      />
      <div className="max-h-[300px] overflow-auto border-gray-300 p-4">
        <Text type="body" color="black">
          <div
            className="ql-editor"
            dangerouslySetInnerHTML={{
              __html: sanitizeRichText(
                experience?.cancelConditions.text ??
                  experience?.cancelConditions ??
                  '',
              ),
            }}
          />
        </Text>
      </div>
    </KoobCard>
  );
};

export default ExperienceCancelConditions;
